<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  width?: number;
  height?: number;
}>();

const originalWidth = 218;
const originalHeight = 160;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    viewBox="0 0 218 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1665_12037)">
      <path
        d="M124.779 47.7618L106.743 71.0856C106.177 71.9354 105.044 72.0299 104.194 71.3689L81.7197 53.7108C80.8699 53.1442 80.7754 52.0111 81.4364 51.1612L104.855 21.4163C105.421 20.5664 106.554 20.472 107.404 21.133L123.74 33.9753L124.779 47.7618Z"
        fill="#5C6479"
      />
    </g>
    <path
      d="M117.13 36.5243L106.271 28.0257C106.082 27.8369 105.988 27.5536 106.177 27.1759C106.365 26.987 106.649 26.8926 107.027 27.0815L117.886 35.58C118.075 35.7689 118.169 36.0522 117.98 36.4299C117.697 36.7132 117.414 36.7131 117.13 36.5243Z"
      fill="#2E3746"
    />
    <path
      d="M108.443 33.8809L104.383 30.5759C104.194 30.387 104.099 30.1038 104.288 29.7261C104.477 29.4428 104.76 29.4428 105.138 29.6316L109.198 32.9366C109.387 33.1255 109.482 33.4088 109.293 33.7865C109.01 34.0698 108.632 34.0698 108.443 33.8809Z"
      fill="#2E3746"
    />
    <path
      d="M123.74 33.9746L118.735 40.3013C117.98 41.2456 118.263 42.5676 119.113 43.2286L124.873 47.7611"
      fill="#2E3746"
    />
    <path
      d="M117.791 49.1791L112.126 44.8354L106.271 40.2084L100.889 35.9592C100.322 35.487 99.3778 35.5814 98.9056 36.2424L91.1625 46.063C90.6904 46.6296 90.7848 47.5738 91.3514 48.046L108.348 61.4548C108.915 61.9269 109.859 61.8325 110.331 61.1715L118.075 51.351C118.547 50.5011 118.452 49.7457 117.791 49.1791ZM99.8499 49.0847L101.55 46.8184L106.743 50.8788L105.043 53.1451L99.8499 49.0847ZM104.571 53.8061L102.966 55.8835L97.7725 51.8231L99.3778 49.7457L104.571 53.8061ZM109.009 48.046L107.31 50.3123L102.116 46.2518L103.816 43.9856L109.009 48.046ZM104.288 43.3246L106.177 41.0583L111.37 45.1187L109.67 47.385L104.288 43.3246ZM113.731 55.317L107.971 50.7844L109.67 48.5181L115.431 53.0507L113.731 55.317ZM101.455 45.6853L95.8839 41.3416L97.5836 39.0753L103.155 43.419L101.455 45.6853ZM95.3173 42.0026L100.889 46.3463L99.1889 48.6125L93.6176 44.2688L95.3173 42.0026ZM107.499 51.4454L113.259 55.978L111.559 58.2442L105.799 53.7117L107.499 51.4454ZM117.414 50.69L115.997 52.4841L110.237 47.9515L111.937 45.6853L117.225 49.8401C117.602 50.029 117.602 50.4067 117.414 50.69ZM100.322 36.4313L105.421 40.4917L103.721 42.758L98.1502 38.4143L99.5666 36.6202C99.7555 36.3369 100.133 36.3369 100.322 36.4313ZM91.8235 46.4407L93.0511 44.9298L98.6223 49.2735L97.0171 51.351L91.8235 47.2906C91.6346 47.1017 91.6346 46.6295 91.8235 46.4407ZM108.915 60.5105L103.627 56.3557L105.232 54.2782L110.992 58.8108L109.67 60.4161C109.482 60.7938 109.104 60.7938 108.915 60.5105Z"
      fill="#2E3746"
    />
    <path
      d="M168.732 62.6621H67.0267C64.935 62.6621 63.1049 64.4929 63.1049 66.5852V132.231C63.1049 134.324 64.935 133.539 67.0267 133.539H168.471C170.562 133.539 172.393 134.324 172.393 132.231V66.5852C172.654 64.4929 170.824 62.6621 168.732 62.6621Z"
      fill="#262A31"
    />
    <path
      d="M165.314 66.4766H70.6645C68.718 66.4766 67.0147 68.1155 67.0147 69.9887V128.758C67.0147 130.631 68.718 129.928 70.6645 129.928H165.071C167.018 129.928 168.721 130.631 168.721 128.758V69.9887C168.964 68.1155 167.261 66.4766 165.314 66.4766Z"
      fill="#474E61"
    />
    <path
      d="M187.818 129.877V131.969C187.818 134.323 185.727 136.415 183.374 136.415H52.3852C50.0321 136.415 47.9405 134.323 47.9405 131.969V129.877H187.818Z"
      fill="#353B4A"
    />
    <path
      d="M130.037 129.877V130.662C130.037 131.969 128.991 133.277 127.422 133.277H108.075C106.768 133.277 105.46 132.231 105.46 130.662V129.877H130.037Z"
      fill="#262A31"
    />
    <path
      d="M128.207 96.9244H119.579V88.2937C119.579 87.2475 118.795 86.4629 117.749 86.4629C116.703 86.4629 115.919 87.2475 115.919 88.2937V96.9244H107.291C106.245 96.9244 105.46 97.709 105.46 98.7552C105.46 99.8013 106.245 100.586 107.291 100.586H115.919V109.217C115.919 110.263 116.703 111.047 117.749 111.047C118.795 111.047 119.579 110.263 119.579 109.217V100.586H128.207C129.253 100.586 130.037 99.8013 130.037 98.7552C130.037 97.709 129.253 96.9244 128.207 96.9244Z"
      fill="#8E96AB"
    />
    <g filter="url(#filter1_d_1665_12037)">
      <path
        d="M187.564 96.0165L158.64 111.674C156.968 112.569 154.893 111.964 153.98 110.288L139.032 82.5931C138.138 80.9195 138.743 78.8427 140.418 77.9279L169.341 62.2704C171.013 61.3751 173.088 61.9804 174.001 63.6561L188.968 91.3535C189.862 93.0271 189.236 95.1211 187.564 96.0165Z"
        fill="url(#paint0_linear_1665_12037)"
      />
    </g>
    <path
      d="M183.725 92.7353L158.294 106.501C157.582 106.893 156.689 106.617 156.297 105.904L143.938 83.0027C143.546 82.2901 143.823 81.3963 144.535 81.0037L169.966 67.2384C170.678 66.8457 171.571 67.1224 171.963 67.835L184.321 90.7362C184.713 91.4488 184.437 92.3426 183.725 92.7353Z"
      fill="#5B6379"
    />
    <path
      d="M166.839 90.6727L157.554 95.6955L159.345 87.928L166.839 90.6727Z"
      fill="#474E61"
    />
    <path
      d="M174.515 86.5128L161.15 93.7557L163.735 82.575L174.515 86.5128Z"
      fill="#2E3746"
    />
    <path
      d="M156.007 86.8469C157.1 86.9689 158.086 86.1805 158.208 85.0859C158.33 83.9914 157.543 83.0051 156.449 82.8831C155.356 82.761 154.371 83.5494 154.248 84.644C154.126 85.7386 154.914 86.7249 156.007 86.8469Z"
      fill="#474E61"
    />
    <g filter="url(#filter2_d_1665_12037)">
      <path
        d="M190.734 101.978L157.85 102.629C155.954 102.658 154.388 101.168 154.345 99.2604L153.762 67.7942C153.735 65.897 155.225 64.329 157.132 64.2838L190.016 63.6333C191.912 63.6044 193.478 65.0935 193.521 67.0015L194.12 98.4785C194.147 100.376 192.63 101.949 190.734 101.978Z"
        fill="url(#paint1_linear_1665_12037)"
      />
    </g>
    <path
      d="M188.827 97.302L159.915 97.8726C159.102 97.8951 158.436 97.2398 158.414 96.4268L157.934 70.4082C157.912 69.5951 158.568 68.9278 159.38 68.9053L188.292 68.3347C189.105 68.3122 189.771 68.9674 189.793 69.7805L190.274 95.7991C190.295 96.6121 189.64 97.2795 188.827 97.302Z"
      fill="#5B6379"
    />
    <path
      d="M174.767 87.7266L164.212 87.9322L169.365 81.8506L174.767 87.7266Z"
      fill="#354156"
    />
    <path
      d="M183.496 87.5503L168.297 87.858L175.721 79.1072L183.496 87.5503Z"
      fill="#2E3746"
    />
    <path
      d="M166.895 79.3593C167.81 79.9691 169.048 79.7204 169.658 78.8037C170.269 77.887 170.021 76.6495 169.106 76.0397C168.19 75.4299 166.953 75.6787 166.342 76.5954C165.732 77.512 165.979 78.7495 166.895 79.3593Z"
      fill="#354156"
    />
    <path
      d="M191.069 103.147L184.094 105.298L189.649 113.514L185.122 116.575L179.567 108.359L174.973 114.031L171.003 90.8159L191.069 103.147Z"
      fill="#8E96AB"
    />
    <g filter="url(#filter3_d_1665_12037)">
      <path
        d="M52.8902 67.949L70.5901 87.7341C71.185 88.4187 71.0021 89.5224 70.2168 90.2248L47.7993 110.274C47.0139 110.976 45.8847 110.991 45.3168 110.337L22.927 84.5711C22.3321 83.8864 22.5149 82.7828 23.3003 82.0804L39.5423 67.5543L52.8902 67.949Z"
        fill="#5C6479"
      />
    </g>
    <path
      d="M38.7471 66.6934L43.8321 72.6996C44.5463 73.5431 45.86 73.5895 46.7036 72.8753L52.0349 68.3616"
      fill="#2E3746"
    />
    <g clip-path="url(#clip0_1665_12037)">
      <path
        d="M33.9065 71.3164L32.6101 72.4141L33.3646 73.3052L34.661 72.2076L33.9065 71.3164Z"
        fill="#2E3746"
      />
      <path
        d="M35.9701 71.0996L34.6736 72.1973L35.4281 73.0884L36.7246 71.9908L35.9701 71.0996Z"
        fill="#2E3746"
      />
      <path
        d="M35.4049 73.086L34.1085 74.1836L34.863 75.0748L36.1594 73.9771L35.4049 73.086Z"
        fill="#2E3746"
      />
      <path
        d="M37.4684 72.8692L36.172 73.9668L36.9265 74.858L38.2229 73.7603L37.4684 72.8692Z"
        fill="#2E3746"
      />
      <path
        d="M36.9139 74.8692L35.6174 75.9668L36.3719 76.858L37.6684 75.7603L36.9139 74.8692Z"
        fill="#2E3746"
      />
      <path
        d="M38.9774 74.6524L37.6809 75.75L38.4354 76.6412L39.7319 75.5435L38.9774 74.6524Z"
        fill="#2E3746"
      />
      <path
        d="M38.4122 76.6387L37.1158 77.7363L37.8703 78.6275L39.1667 77.5299L38.4122 76.6387Z"
        fill="#2E3746"
      />
      <path
        d="M40.4758 76.4219L39.1793 77.5195L39.9338 78.4107L41.2303 77.3131L40.4758 76.4219Z"
        fill="#2E3746"
      />
      <path
        d="M39.9212 78.42L38.6248 79.5176L39.3793 80.4087L40.6757 79.3111L39.9212 78.42Z"
        fill="#2E3746"
      />
      <path
        d="M41.9848 78.2032L40.6883 79.3008L41.4428 80.1919L42.7393 79.0943L41.9848 78.2032Z"
        fill="#2E3746"
      />
      <path
        d="M41.4196 80.1914L40.1232 81.2891L40.8777 82.1802L42.1741 81.0826L41.4196 80.1914Z"
        fill="#2E3746"
      />
      <path
        d="M43.4831 79.9727L42.1867 81.0703L42.9412 81.9615L44.2376 80.8638L43.4831 79.9727Z"
        fill="#2E3746"
      />
      <path
        d="M42.9286 81.9727L41.6321 83.0703L42.3866 83.9615L43.6831 82.8638L42.9286 81.9727Z"
        fill="#2E3746"
      />
      <path
        d="M44.9815 81.7422L43.685 82.8398L44.4395 83.731L45.7359 82.6334L44.9815 81.7422Z"
        fill="#2E3746"
      />
      <path
        d="M44.4269 83.7422L43.1305 84.8398L43.885 85.731L45.1814 84.6334L44.4269 83.7422Z"
        fill="#2E3746"
      />
      <path
        d="M46.4905 83.5254L45.194 84.623L45.9485 85.5142L47.245 84.4166L46.4905 83.5254Z"
        fill="#2E3746"
      />
      <path
        d="M44.6395 86.623L48.1676 90.7902L50.773 88.5843L47.245 84.4171L44.6395 86.623ZM50.0534 88.5255L48.2283 90.0707L47.2082 88.8658L49.0333 87.3206L50.0534 88.5255Z"
        fill="#2E3746"
      />
      <path
        d="M50.526 99.7781L50.4616 97.6347C50.4698 97.2615 50.4701 96.9811 50.4889 96.6204L50.4783 96.6078L49.0559 97.812L48.3864 97.0213L51.0423 94.7727L51.5524 95.3752L51.614 97.4133C51.6184 97.7759 51.6248 98.1152 51.5848 98.4508L51.5954 98.4633L53.1562 97.1419L53.8363 97.9452L51.0042 100.343L50.526 99.7781Z"
        fill="#2E3746"
      />
      <path
        d="M52.1652 92.2705C52.399 92.5466 52.3763 92.9537 52.049 93.2308C51.7344 93.4972 51.3291 93.4524 51.0953 93.1763C50.8383 92.8982 50.861 92.4912 51.1883 92.2141C51.5262 91.9496 51.9208 91.9818 52.1652 92.2705ZM54.6292 97.2738L51.8982 94.048L52.9051 93.1955L55.6362 96.4213L54.6292 97.2738Z"
        fill="#2E3746"
      />
      <path
        d="M54.6246 93.5924C54.2633 93.1657 53.9426 92.8123 53.6856 92.5343L54.5541 91.799L54.987 92.2082L54.9996 92.1976C54.9518 91.6562 55.1574 91.1589 55.6357 90.7539C56.3406 90.1572 57.5032 90.2287 58.3746 91.2579C59.3735 92.4378 59.0985 93.6188 58.3684 94.2369C57.9782 94.5672 57.538 94.6598 57.2169 94.5869L57.2043 94.5975L58.5645 96.2041L57.5576 97.0567L54.6246 93.5924ZM56.2798 93.5055C56.3436 93.5809 56.4199 93.6455 56.4856 93.6976C56.7824 93.9205 57.1915 93.9188 57.481 93.6737C57.9216 93.3007 57.8651 92.7236 57.3976 92.1713C56.9619 91.6567 56.4059 91.4594 55.9528 91.8431C55.6633 92.0882 55.5922 92.5147 55.7843 92.8692C55.8142 92.9301 55.8547 93.0035 55.9079 93.0662L56.2798 93.5055Z"
        fill="#2E3746"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1665_12037"
        x="59.0027"
        y="9.69922"
        width="87.7764"
        height="95.1035"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1665_12037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1665_12037"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1665_12037"
        x="116.62"
        y="50.8574"
        width="94.7552"
        height="94.2285"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1665_12037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1665_12037"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1665_12037"
        x="131.761"
        y="52.6328"
        width="84.3594"
        height="82.9961"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1665_12037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1665_12037"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_1665_12037"
        x="0.575226"
        y="56.5547"
        width="92.3666"
        height="87.2598"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1665_12037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1665_12037"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1665_12037"
        x1="166.969"
        y1="60.1898"
        x2="161.062"
        y2="113.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1665_12037"
        x1="188.862"
        y1="60.6967"
        x2="159.34"
        y2="105.024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <clipPath id="clip0_1665_12037">
        <rect
          width="11.4951"
          height="34.0431"
          fill="white"
          transform="translate(29.5515 75.0039) rotate(-40.2525)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
